import { useState } from 'react';
import emailjs from '@emailjs/browser';
import styles from './contact.module.css';
import FAB from '../../helpers/fab'

import { logContactFormSubmission, logContactFormSubmissionFailure } from "../../helpers/google-analytics/gaEvents";

const Modal = ({ message, onClose }) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <p>{message}</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);

    if (!formData.name || !formData.email || !formData.message || !formData.phone || !formData.subject) {
      setIsSending(false);
      return;
    }

    emailjs.send(
      'service_0ujkyaj',
      'template_dsuhhlr',
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
      },
      'XSDUHGv-DD6Bu91Su'
    ).then(() => {
      setModalMessage('Message sent! Thank you for contacting us.');
      setShowModal(true);
      setFormData({ name: '', email: '', message: '', phone: '', subject: '' });
      setIsSending(false);
      logContactFormSubmission();
    }).catch((err) => {
      setModalMessage('Oops, something went wrong. Please try again.');
      setShowModal(true);
      setIsSending(false);

      const errorLabel = err?.text || err?.message || 'Unknown error';
      logContactFormSubmissionFailure(errorLabel);
    });

  };

  return (
    <section className={styles.contactContainer}>
      <div className={styles.contactLeft}>
        <div className={styles.contactImageOverlay} />
        <div className={styles.contactInfoContent}>
          <h2>Contact Us</h2>
          <p>Whether you're planning a small change or a full renovation, contact 1 Stop Kitchens to speak to an expert.</p>
          <p><strong>📞 Phone:</strong> (506) 458-8801</p>
          <p><strong>📧 Email:</strong> 1stopkitchens@nb.aibn.com</p>
          <p><strong>📍 Address:</strong> 7 Royal Parkway, Fredericton, NB</p>
          <div className={styles.mapContainer}>
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2756.301432643539!2d-66.66346458470825!3d45.95082697468542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ca4225c3fc8c44d%3A0xc1d870a35fc63d02!2s7%20Royal%20Pkwy%2C%20Fredericton%2C%20NB%20E3G%200J9!5e0!3m2!1sen!2sca!4v1692713823810!5m2!1sen!2sca"
              width="100%"
              height="200"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit} className={styles.contactForm}>
        <h3>Send Us a Message</h3>

        <label>
          Name:
          <input 
            type="text" 
            name="name" 
            value={formData.name} 
            onChange={handleChange} 
            required 
          />
        </label>

        <label>
          Phone:
          <input 
            type="tel" 
            name="phone" 
            value={formData.phone} 
            onChange={handleChange} 
            required 
          />
        </label>

        <label>
          Email:
          <input 
            type="email" 
            name="email" 
            value={formData.email} 
            onChange={handleChange} 
            required 
          />
        </label>

        <label>
          Subject:
          <input 
            type="text" 
            name="subject" 
            value={formData.subject} 
            onChange={handleChange} 
            required 
          />
        </label>

        <label>
          Message:
          <textarea 
            name="message" 
            value={formData.message} 
            onChange={handleChange} 
            rows="5" 
            required 
          />
        </label>

        <button disabled={isSending} className={isSending ? styles.disableButton : null} type="submit">{isSending ? 'Sending...' : 'Send Message'}</button>
        {showModal && (
          <Modal message={modalMessage} onClose={() => setShowModal(false)} />
        )}
      </form>
    
      <FAB />
    </section>
  );
};

export default Contact;